import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { PostReviewModuleName } from '@/store/modules/modules'

export class PostReviewViewModel {
  private store = useStore()

  reviewList: ComputedRef<{ [entryId: string]: string }> = computed(
    () => this.store.getters[`${PostReviewModuleName}/reviewList`]
  )
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${PostReviewModuleName}/isLoading`])
  error: ComputedRef<Error | null> = computed(() => this.store.getters[`${PostReviewModuleName}/error`])

  setReviewList(reviewList: { [entryId: string]: string }): void {
    this.store.commit(`${PostReviewModuleName}/setReviewList`, { reviewList })
  }

  setReview(entryId: string, message: string): void {
    this.store.commit(`${PostReviewModuleName}/setReview`, { entryId, message })
  }

  async postReview(entryId: string, message: string, reviewerId: string): Promise<void> {
    await this.store.dispatch(`${PostReviewModuleName}/postReview`, { entryId, message, reviewerId })
  }
}
